import { useQuery } from "@tanstack/react-query";
import { ActionsTable } from "Common/Components";
import { useSpecialPermissionStore } from "feature/specialpermissions/store";
import { NotificationType, showNotifications } from "helpers/toas_notification";
import { SpecialPermission } from "interfaces";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { DeleteSpecialPermission, FetchSpecialPermission } from "services";

export const useListSpecialPermissions = () => {
  const { setIsEdit, setIsOpenModal, setItem } = useSpecialPermissionStore();
  const [modalDelete, setModalDelete] = useState<boolean>(false);
  const [idSpecialPermission, setIdSpecialPermission] = useState<number>(0);
  const deleteToggle = () => setModalDelete(!modalDelete);
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        header: "ID",
        accessorKey: "index",
        cell: (cell: any) => cell.row.index + 1,
        enableColumnFilter: false,
      },
      {
        header: t("SpecialPermission.label.description"),
        accessorKey: "description",
        enableColumnFilter: false,
      },
      {
        header: t("SpecialPermission.label.action"),
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => {
          const rowData = cell.row.original;
          return (
            <ActionsTable
              onClickEdith={() => handleEdit(rowData)}
              onClickDelete={() => handleDelete(rowData)}
            />
          );
        },
      },
    ],
    []
  );

  const { data: dataspecialpermissions, refetch: refetchSpecialPermission } =
    useQuery({
      queryKey: ["security-service-specialpermissions"],
      queryFn: FetchSpecialPermission,
    });

  const handleDelete = (data: SpecialPermission) => {
    setIdSpecialPermission(data.id);
    setModalDelete(true);
  };
  const handleEdit = (data: SpecialPermission) => {
    setIsEdit(true);
    setIsOpenModal(true);
    setItem(data);
  };

  const deleteSpecialPermission = async () => {
    try {
      const response = await DeleteSpecialPermission(idSpecialPermission);

      if (response.code === "200") {
        setModalDelete(false);
        refetchSpecialPermission();

        showNotifications(
          NotificationType.SUCCESS,
          t("deleteModal.succedDelete")
        );
      } else {
        showNotifications(
          NotificationType.ERROR,
          t("deleteModal.errorDelete" + response.message)
        );
      }
    } catch (error) {
      showNotifications(NotificationType.ERROR, t("deleteModal.errorDelete"));
    }
  };

  return {
    specialpermissions: dataspecialpermissions?.data,
    columns,
    refetchSpecialPermission,
    modalDelete,
    deleteToggle,
    deleteSpecialPermission,
  };
};
